export default __webpack_public_path__ + "static/media/icon-close-search.6b376209.svg";